/* eslint-disable max-len */
export default {
    products: {
        sku: 'Код товара',
        productName: 'Наименование товара',
        quantity: 'Кол-во товара',
        productCommentClient: 'Комментарий клиента',
        productPrice: 'Цена за шт',
        productPriceRegular: 'Цена за шт по карте',
        sum: 'Сумма за позицию',
        productProperties: 'Характеристики',
        sumWithDiscount: 'Сумма за позицию (с учетом баллов)',
    },

    print: {
        title: 'Печать заказа',
        titleWait: 'Создается задача на формирование, ожидайте',
        button: 'Печать заказа',
        startAssembly: 'Начать сборку',
        defaultTitleModal: 'Распечатать заказ?',
        assemblyTitleModal: 'Приступить к сборке заказа?',
        okTitleModal: 'Да',
        cancelTitleModal: 'Нет',
        textInfo: `<span>Внимание!</span> <span>Обязательно</span> сформируйте заказ в CRM перед сканированием мягкого чека на кассе. Если не сформировать заказ, то на кассе отобразится ошибка <span>"Чек не найден"</span>.`,
        addItemToReceipt: "Функция 'Добавление товара в чек' недоступна. Добавление новой товарной позиции только отдельным чеком.",
        printDocs: 'Печать документов',

        docDefinition: {
            text1: 'Заказ № {id}',
            text2: 'Заказ № {id} от {dateCreate}',
            text3: 'Внимание в заказе есть Карта программы лояльности.',
            text4: 'Продажу на кассе осуществить отдельно!',
            text5: 'При предъявлении на кассе карты Fix Price, стоимость товаров \n' +
          'может быть пересчитана с учетом акции «Спец цена по карте»',
        },

        body: {
            text1: 'Комментарий к заказу клиента:',
            text2: 'Способ доставки:',
            text3: 'Комментарий к заказу сотрудника:',
            text4: 'Адрес доставки:',
            text5: 'Имя клиента:',
            text6: 'Желаемая дата доставки:',
            text7: 'Согласование изменений с клиентом:',
            text8: 'Контактный телефон клиента:',
            text9: 'Способы оплаты:',
            text10: 'Статус оплаты:',
            text11: 'Номер заказа партнёра',
            text12: '№ заказа партнёра',
        },

        getTotal: {
            text1: 'Итого собрано: {totalSum}',
            text2: 'Сумма скидки: {totalSaleSum}',
            text3: 'Заказано покупателем (товары): {totalSumOriginal}',
            text4: 'Итого собрано (товары): {totalSum}',
            text5: 'Стоимость доставки: {deliverySumClient}',
            text10: 'Скидка по промокоду: {promocode}',
            totalWithPromocode: 'Итого с учетом промокода: {sum}',
            totalDelivery: 'Итого собрано (с учетом доставки): {totalDelivery}',
            totalWithDiscount: 'Итого собрано (с учетом скидки и доставки): {totalWithDiscount}',
            totalWithPackages: 'Итого собрано (с учетом пакетов и доставки): {totalWithPackages}',
            totalWithDicountAndPackages: 'Итого собрано (с учетом скидки, доставки и пакетов): {totalWithDicountAndPackages}',
            packageSum: 'Стоимость пакета: {packageSum}',
        },
    },

    printActlssuing: {
        products: {
            sku: 'Код товара',
            productName: 'Наименование товара',
            quantity: 'Кол-во товара',
            productCommentClient: 'Комментарий клиента',
            productPrice: 'Цена за шт (с НДС)',
            sum: 'Сумма за позицию с НДС',
            productProperties: 'Характеристики',
        },

        printTable: 'Акт приема-передачи',

        button: 'Акт выдачи заказа',

        docDefinition: {
            text1: 'Акт приема-передачи заказ № {id}',
            text2: 'Заказ № {id} от {dateCreate}',
            text3: 'Внимание в заказе есть Карта программы лояльности.',
            text4: 'Продажу на кассе осуществить отдельно!',
        },

        getMainInfo: {
            text1: 'Комментарий к заказу клиента:',
            text2: 'Способ доставки:',
            text3: 'Комментарий к заказу сотрудника:',
            text4: 'Адрес доставки:',
            text5: 'Имя клиента:',
            text6: 'Желаемая дата доставки:',
            text7: 'Согласование изменений с клиентом:',
            text8: 'Контактный телефон клиента:',
            text9: 'Способы оплаты:',
            text10: 'Статус оплаты:',
            text11: 'Адрес магазина:',
        },

        getTotal: 'Итого: {totalSum} (с НДС) \n\n',

        getAgreementText: '1. Покупатель не имеет никаких претензий к принятому им товару из интернет-магазина \n 2. Настоящий Акт составлен на русском языке в двух экземплярах, имеющих равную юридическую силу, по одному экземпляру для каждой Стороны.\n',

        getPlaceForSignature: {
            text1: 'От Продавца',
            text2: 'От Покупателя',
            text3: 'Должность',
        },

        getFinalAgreementText: 'Если какой-либо товар не подошел Вам, Вы можете вернуть его в течение 7 календарных дней или обменять в течение 14 календарных дней в соответствии с законодательством РФ (ЗОЗПП No2300-1) и Условиями продажи, размещенным на сайте. Вы можете сдать товар вместе получения заказа, назвав номер заказа, в котором Вам пришел товар, и предоставив распечатанный или электронный чек заказа. Возврат денежных средств: Если Вы оплатили заказ насайте, денежные средства за товар поступят на ту банковскую карту, которой Вы воспользовались при оформлении заказа. Возврат денежных средств на карту осуществляется в течение 10 дней с момента обращения. Если Вы оплатили товар наличными при получении заказа, денежные средства за товар вернут Вам наличными на кассе магазина.',
    },
};